import React from "react";
import { SafeArea, Image, InfiniteScroll, Popover } from "antd-mobile";
import styles from "./index.module.less";
import { FC, useEffect, useState } from "react";
import { game_publicity_title } from "~src/assets/images/answerGame";
import { getPublicity } from "~src/service/answer";
import { RankingListType } from "~src/service/answer/answer";
import { formatTime, getDateRangeString } from "~src/utils/tool";
import { useWXPath } from "~src/hooks/useWXPath";
import useSendCurrentPagePath from "~src/hooks/useSendCurrentPagePath";

const RankingList: FC = () => {
  const wxPath = useWXPath()
  const isPhone = localStorage.getItem("mio-phoneNumber") ? false : true
  const [visible, setVisible] = useState<boolean>(true)
  const [rankdata, setRankdata] = useState<RankingListType[]>([])
  const getWeekRankingData = async () => {
    const { rankingList } = await getPublicity()
    setRankdata(rankingList || [])
  }
  const {sendMessage} = useSendCurrentPagePath()
  sendMessage({
    title: "和绿喵一起涨知识，答对4题赢低碳惊喜好礼",
    type: "share",
    path: "",
    shareQuery: "&share=true&type=all",
    selfQuery: "&share=true&type=all"
  })
  useEffect(() => {
    getWeekRankingData()
  }, [])
  return <div>
    <div className={styles.ranking}>
      <div className={styles["ranking-top"]}>
        <Image src={game_publicity_title} />
        <div className={styles["ranking-top-timer"]}>时间：{getDateRangeString()}</div>
      </div>
      <div className={styles["ranking-header"]}>
        <div >排名</div>
        <div className={styles["ranking-header-info"]}>姓名</div>
        <div className={styles["ranking-header-integral"]}>累计积分</div>
        <div>闯关总时长</div>
      </div>
      <div className={styles["ranking-boby"]}>
        {
          rankdata?.map((ele, index) => {
            return <div className={styles["ranking-boby-item"]} key={ele.nikeName}>
              <div className={styles["ranking-boby-index"]}>
                {ele.order > 3 ? ele.order : <Image src={require(`../../../assets/images/answerGame/game_rank_${index}.png`)}></Image>}
              </div>
              <div className={styles["ranking-boby-info"]}>
                <Image src={ele.avatar}
                  fit='cover'
                  width={27}
                  height={27}
                  className={styles["ranking-boby-info-border0"]}
                  style={{ borderRadius: 32 }} />
                <div className={styles["ranking-boby-info-name"]} >{ele.nikeName}</div>
              </div>
              <div className={styles["ranking-boby-integral"]}>{ele.point}</div>
              <div className={styles["ranking-boby-timer"]}>{formatTime(Number(ele.time), "h-m-s")}</div>
            </div>
          })
        }
      </div>
    </div>
    <InfiniteScroll
      loadMore={async () => void 0}
      hasMore={false} />
    {
      isPhone && <div className={styles["ranking-footer"]}>
        <div className={styles["ranking-footer-box"]}>
          <Popover
            content='排行榜奖品将于2023年03月15日前短信通知。未授权手机号用户无法收到短信哦~'
            trigger='click'
            placement='top'
            visible={visible}
            className={styles.popover}
          >
            <div className={styles["ranking-footer-btn"]}
              onClick={
                () => {
                  wxPath("navigateTo", '/pages/load_bearing/bind_phone/index')
                  setTimeout(() => {
                    localStorage.setItem("mio-phoneNumber", "1")
                     setVisible(false)
                   }, 300)
                }
              }>授权手机号</div>
          </Popover>
        </div>
        <SafeArea position="bottom" />
      </div>
    }

    <SafeArea position="bottom" />
  </div>
}
export default RankingList